import { atom } from 'jotai'
import { focusAtom } from 'jotai-optics'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ConformedBranding, ConformedCampaignDetails, MediaAsset } from '../../views/shared/conformed'

export const [campaignDetailsAtom, useCampaignDetailsListener] = atomWithListeners<
	ConformedCampaignDetails | undefined
>({
	title: '',
	location: '',
	language: '',
	requirements: '',
	invoiceUrl: '',

	branding: {
		id: '',
		name: null,
		logoId: '',
		logo: undefined,
		foreground: '#FFFFFF',
		background: '#4D008C',
		accentForeground: '#FFFFFF',
		accentBackground: '#33CC66',
		toneOfVoice: '',
		visualGuidance: '',
		website: '',
		bodyFont: '',
		titleFont: '',
		generateKeyImage: true,
	},
})

// these ONLY work if the campaign is ready
export const campaignDetailsTitleAtom = focusAtom(campaignDetailsAtom, (optic) => optic.optional().prop('title'))
export const campaignDetailsLocationAtom = focusAtom(campaignDetailsAtom, (optic) => optic.optional().prop('location'))
export const campaignDetailsLanguageAtom = focusAtom(campaignDetailsAtom, (optic) => optic.optional().prop('language'))
export const campaignDetailsRequirementsAtom = focusAtom(
	campaignDetailsAtom,
	(optic) => optic.optional().prop('requirements'),
)
export const campaignDetailsBrandingAtom = focusAtom(
	campaignDetailsAtom,
	(optic) => optic.optional().prop('branding'),
)

export const campaignDetailsLogoAtom = focusAtom(
	campaignDetailsBrandingAtom,
	(optic) => optic.optional().prop('logo'),
)

export const campaignDetailsInvoiceUrlAtom = focusAtom(
	campaignDetailsAtom,
	(optic) => optic.optional().prop('invoiceUrl'),
)

export const campaignDetailsStatusAtom = atom<LifecycleState>('idle')
export const campaignDetailsSavingAtom = atom<PersistenceState>('idle')
export const campaignDetailsGenerationErrorAtom = atom<string | null>(null)

// Regenerate callback atoms
export const campaignDetailsRegenerateFromUrlAtom = atom<
	((url: string, brand: ConformedBranding) => Promise<void>) | undefined
>(undefined)

export const campaignDetailsRegenerateFromManualAtom = atom<
	((
		data: { title: string; location: string; language: string; requirements: string },
		brand: ConformedBranding,
	) => Promise<void>) | undefined
>(undefined)

// Logo upload callback atom
export const campaignDetailsLogoUploadAtom = atom<
	((logo: File, callback: (asset: MediaAsset) => void) => void) | undefined
>(undefined)
